import { render, staticRenderFns } from "./ModalDuplicationFavoris.vue?vue&type=template&id=4a9958d4&"
import script from "./ModalDuplicationFavoris.vue?vue&type=script&lang=js&"
export * from "./ModalDuplicationFavoris.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a9958d4')) {
      api.createRecord('4a9958d4', component.options)
    } else {
      api.reload('4a9958d4', component.options)
    }
    module.hot.accept("./ModalDuplicationFavoris.vue?vue&type=template&id=4a9958d4&", function () {
      api.rerender('4a9958d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Mercuriales/ModalDuplicationFavoris.vue"
export default component.exports